import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      className="toaster group"
      position="top-right"
      toastOptions={{
        classNames: {
          toast: "jw-toast group toast",
          title: "jw-toast-title",
          description: "jw-toast-desc",
          actionButton: "jw-toast-action",
          cancelButton: "jw-toast-cancel",
          success: "jw-toast-success",
          error: "jw-toast-error",
          info: "jw-toast-info",
          warning: "jw-toast-warning",
          icon: "jw-toast-icon",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
